import React, { useState } from "react";
import css from "./google-maps.module.scss";

type LocationKey = "groteweg" | "prinsClausweg";

const locations: Record<LocationKey, { label: string; url: string }> = {
    groteweg: {
        label: "Groteweg 9",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2468.6931765691204!2d4.711010315753116!3d51.92441977957086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47cf4f66036b3da7:0x5b71bdf4f97981b2!2sGroteweg+9%2C+1756+CK+%27t+Zand!5e0!3m2!1sen!2snl!4v1692140762313!5m2!1sen!2snl"
    },
    prinsClausweg: {
        label: "Prins Clausweg 1-3",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2468.6931765691204!2d4.762122865166113!3d52.84486172157128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47cf4f404628b3b1:0xdb6c9be06f537dcf!2sPrins+Clausweg+1-3%2C+1756+BJ+%27t+Zand!5e0!3m2!1sen!2snl!4v1692140762313!5m2!1sen!2snl"
    }
};

const GoogleMaps: React.FC = () => {
    const [selectedKey, setSelectedKey] = useState<LocationKey>("groteweg");

    return (
        <div>
            <div className={css.buttonGroup}>
                <button
                    className={`${css.button} ${selectedKey === "groteweg" ? css.active : ""}`}
                    onClick={() => setSelectedKey("groteweg")}
                >
                    {locations.groteweg.label}
                </button>
                <button
                    className={`${css.button} ${selectedKey === "prinsClausweg" ? css.active : ""}`}
                    onClick={() => setSelectedKey("prinsClausweg")}
                >
                    {locations.prinsClausweg.label}
                </button>
            </div>
            <div className={css.mapContainer}>
                <iframe
                    title="Google Map"
                    src={locations[selectedKey].url}
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                ></iframe>
            </div>
        </div>
    );
};

export default GoogleMaps;